import { Box, Popover } from '@mui/material';
import { ReactNode } from 'react';
import { DRAWER_WIDTH } from '../SidenavDrawer';
import { getSidenavBackgroundColor, getSidenavTextColor } from '../sidenav-colors';

interface SidenavPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  children: ReactNode;
}

/**
 * Shared Popover component for sidenav items with consistent styling.
 * Handles positioning and styling for hover tooltips/popovers in collapsed sidenav.
 */
export function SidenavPopover({
  open,
  anchorEl,
  onClose,
  onMouseEnter,
  onMouseLeave,
  children,
}: SidenavPopoverProps) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableRestoreFocus
      sx={{
        pointerEvents: 'none',
        '& .MuiPaper-root': {
          pointerEvents: 'auto',
          backgroundColor: getSidenavBackgroundColor,
          color: getSidenavTextColor,
          marginLeft: '8px',
          minWidth: `${DRAWER_WIDTH}px`,
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.3)',
        },
      }}
    >
      <Box onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {children}
      </Box>
    </Popover>
  );
}
